enum AccountState {
    Active = "ACTIVE",
    ReadOnly = "READ_ONLY",
    Closed = "CLOSED",
}
export default AccountState